import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import _Attributes from 'src/pages/ProductEditor/Components/Attributes';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Attributes = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { avaAtt, onAttOptionsChange, productUuid, disabled } = props;
  console.log('----avaAtt: ', avaAtt);
  return (
    <SectionWrapper
      title={getI18n('allProducts.addproductset.attributes_Discard_title')}>
      <_Attributes
        disabled={disabled}
        avaAtt={avaAtt || []}
        onAttOptionsChange={onAttOptionsChange}
        productUuid={productUuid}
      />
    </SectionWrapper>
  );
};
export default Attributes;
